import { Grid, Modal } from '@material-ui/core'
import React from 'react'
import CloseIcon from '@material-ui/icons/CloseOutlined'
import './index.scss'

const Modals = (props) => {
    return (
        <Modal
            aria-labelledby={props.title}
            aria-describedby={props.description}
            open={props.open}
            onClose={props.onClose}
            style={{
                alignItems: 'center',
                justifyContent: 'center',
            }}
            {...props}>
            <div className="modals-container">
                <header>
                    <span>{props.title}</span>
                    <CloseIcon
                        style={{
                            color: '#FFF',
                            cursor: 'pointer',
                        }}
                        onClick={props.onClose}
                    />
                </header>
                {/* <body style={{height: props.showfooter ? "80%" : "90%"}}> */}
                <body
                    className={
                        props.footer &&
                        props.footer != undefined
                            ? 'show-footer'
                            : ''
                    }>
                    {props.children}
                </body>
                {props.footer &&
                    props.footer != undefined && (
                        <footer>{props.footer}</footer>
                    )}
            </div>
        </Modal>
    )
}

/* Modals.defaultProps = {
  showfooter: true,
} */
/* Modals.Header = function (props) {
  return props.children;
} */

export default Modals
